<br>
<div class="container bootstrap snippet">
    <div class="row">
        <div class="col-sm-3">
            <ng-template [ngIf]="modoVisualizacion === 'edicion'">
                <!--left col-->
                <h1 class="text-center">{{userData.nickname}}</h1>
                <div class="text-center">
                    <img *ngIf="userImageUrlSanitizer==null" src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
                        class="avatar img-circle img-thumbnail" alt="avatar">
                    <img *ngIf="userImageUrlSanitizer!=null" [src]="userImageUrlSanitizer"
                        class="avatar img-circle img-thumbnail" alt="avatar">
                    <!-- <input type="file" class="text-center center-block file-upload"> -->
                    <input type="file" id="boton-imagen" hidden accept=".jpg,.png,.jpeg" (change)="getImage($event)" />
                    <label id="boton-imagen-label" for="boton-imagen">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-upload" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                            <path fill-rule="evenodd"
                                d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                        </svg>
                        Cambiar imagen
                    </label>
                </div><br>
            </ng-template>
            <ng-template [ngIf]="modoVisualizacion === 'vista'">
                <!--left col-->
                <h1 class="text-center">{{userData.nickname}}</h1>
                <div class="text-center">
                    <img *ngIf="userImageUrlSanitizer==null" src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png"
                        class="avatar img-circle img-thumbnail" alt="avatar">
                    <img *ngIf="userImageUrlSanitizer!=null" [src]="userImageUrlSanitizer"
                        class="avatar img-circle img-thumbnail" alt="avatar">
                    <!-- <input type="file" class="text-center center-block file-upload"> -->
                </div><br>
            </ng-template>
        </div>
        <!--/col-3-->

        <div class="col-sm-9">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                        aria-controls="profile" aria-selected="true">Datos personales</a>
                </li>
                <li *ngIf="userData.profile==profileTypes.Creador" class="nav-item">
                    <a class="nav-link" id="created-tab" data-toggle="tab" href="#created" role="tab"
                        aria-controls="created" aria-selected="false">Tours creados</a>
                </li>
            </ul>

            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <ng-template [ngIf]="modoVisualizacion === 'edicion'">
                        <hr>
                        <form class="form" action="##" method="post" id="registrationForm">
                            <div class="form-group">

                                <div class="col-xs-6">
                                    <label for="first_name">
                                        <h4>Nombre</h4>
                                    </label>
                                    <input type="text" class="form-control" name="first_name" id="first_name"
                                        placeholder="first name" title="enter your first name if any."
                                        [(ngModel)]="userDataCopy.name">
                                </div>
                            </div>
                            <div class="form-group">

                                <div class="col-xs-6">
                                    <label for="last_name">
                                        <h4>Apellidos</h4>
                                    </label>
                                    <input type="text" class="form-control" name="last_name" id="last_name"
                                        placeholder="last name" title="enter your last name if any."
                                        [(ngModel)]="userDataCopy.lastname">
                                </div>
                            </div>

                            <div class="form-group">

                                <div class="col-xs-6">
                                    <label for="nickname">
                                        <h4>Nombre de usuario</h4>
                                    </label>
                                    <input type="text" class="form-control" name="nickname" id="nickname"
                                        placeholder="enter nickname" title="enter your nickname."
                                        [(ngModel)]="userDataCopy.nickname">
                                </div>
                            </div>

                            <div class="col-xs-6">
                                <label for="email">
                                    <h4>Email</h4>
                                </label>
                                <input type="email" readonly class="form-control" name="email" id="email"
                                    placeholder="you@email.com" title="enter your email." value={{userData.email}}>
                            </div>
                            <br>
                            <div *ngIf="userData.profile==profileTypes.Estandar" class="form-check col-xs-6">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                                    style="height: 40px; width: 25px;" (change)="onCheckConvertirEnCreador($event)">
                                <label class="form-check-label" for="flexCheckDefault" style="margin-left: 20px;">
                                    Convertirme en creador <p style="font-style: italic;font-size: 12px">Esta acción no
                                        se puede deshacer</p>
                                </label>
                            </div>
                        </form>
                        <div class="form-group">
                            <div class="col-xs-12">
                                <br>
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <button class="btn btn-info" type="submit" (click)="onSave()">
                                        Guardar cambios</button>
                                    <button class="btn btn-secondary" type="reset" (click)="onCancel()">
                                        Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template [ngIf]="modoVisualizacion === 'vista'">
                        <hr>
                        <form class="form" action="##" method="post" id="registrationForm">
                            <div class="form-group">

                                <div class="col-xs-6">
                                    <label for="first_name">
                                        <h4>Nombre</h4>
                                    </label>
                                    <input type="text" readonly class="form-control-plaintext" name="first_name"
                                        id="first_name" placeholder="-" title="enter your first name if any."
                                        value={{userData.name}}>
                                </div>
                            </div>
                            <div class="form-group">

                                <div class="col-xs-6">
                                    <label for="last_name">
                                        <h4>Apellidos</h4>
                                    </label>
                                    <input type="text" readonly class="form-control-plaintext" name="last_name"
                                        id="last_name" placeholder="-" title="enter your last name if any."
                                        value={{userData.lastname}}>
                                </div>
                            </div>

                            <div class="form-group">

                                <div class="col-xs-6">
                                    <label for="nickname">
                                        <h4>Nombre de usuario</h4>
                                    </label>
                                    <input type="text" readonly class="form-control-plaintext" name="nickname"
                                        id="nickname" placeholder="-" title="enter your nickname."
                                        value={{userData.nickname}}>
                                </div>
                            </div>

                            <div class="col-xs-6">
                                <label for="email">
                                    <h4>Email</h4>
                                </label>
                                <input type="email" readonly class="form-control-plaintext" name="email" id="email"
                                    placeholder="-" title="enter your email." value={{userData.email}}>
                            </div>
                        </form>
                        <div class="form-group">
                            <div class="col-xs-12">
                                <br>
                                <button class="btn btn-info" type="submit" (click)="onEdit()">
                                    Editar</button>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div *ngIf="userData.profile==profileTypes.Creador" class="tab-pane fade" id="created" role="tabpanel"
                    aria-labelledby="created-tab">
                    <br>
                    <div class="container container-full">
                        <div class="row">
                            <ng-container *ngFor="let tour of toursCreados">
                                <div class="col-md-4">
                                    <div class="card mb-4 box-shadow">
                                        <button type="button" class="close delete-tour" data-dismiss="modal"
                                            aria-label="Close" (click)="onDeleteTour(tour.id)">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <img *ngIf="tour.imageSanitizer != null" class="card-img-top"
                                            [src]="tour.imageSanitizer" alt="Imagen del tour"
                                            style="height: 125px; object-fit: cover;">
                                        <img *ngIf="tour.imageSanitizer == null" class="card-img-top"
                                            src="assets/no-image.png" alt="Imagen del tour sin image"
                                            style="height: 125px; object-fit: cover;">
                                        <div class="card-body" style="height: 200px;">
                                            <h2 class="justify-content-center truncate" style="font-size: 1em;">
                                                {{tour.name}}</h2>
                                            <p class="card-text truncate-description"
                                                style="height: 75px; font-size: 0.8rem">{{tour.description}}</p>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="btn-group">
                                                    <button type="button" class="btn btn-sm btn-outline-secondary"
                                                        routerLink='/tour/{{tour.id}}/vista'>Ver</button>
                                                </div>
                                                <!-- <small class="text-muted">9 mins</small> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>


                        <!-- <ng-container *ngFor="">
                            <div class="col col-lg-4 d-flex justify-content-center" routerLink='tour/{{tour.id}}'>
                                <div class="">
                                    <img class="rounded-circle justify-content-center" src="{{tour.image}}"
                                        alt="Generic placeholder image" width="140" height="140">
                                    <h2 class="justify-content-center">{{tour.name}}</h2>
                                </div>
                            </div>
                        </ng-container> -->
                    </div>
                </div>
            </div>




        </div>
        <!--/tab-pane-->
    </div>
    <!--/tab-content-->

</div>
<!--/col-9-->